import { createFileRoute } from '@tanstack/react-router';

type Search = {
  authToken?: string;
  locationId?: string;
  personId?: string;
  sourceId?: string;
  personPMSId?: string;
  showTuuthfairyReport?: boolean;
};
/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/insurance-eligibility-report')({
  validateSearch: (search: Partial<Search>) => {
    return {
      authToken: search?.authToken,
      locationId: search?.locationId,
      personId: search?.personId,
      sourceId: search?.sourceId,
      personPMSId: search?.personPMSId,
      showTuuthfairyReport: search?.showTuuthfairyReport ?? false,
    };
  },
});
